import Button from '../components/Button';
import { showRightArrowIcon, showRightArrowWhiteIcon } from '../core/core';
import styles from './ClassroomCardButton.module.scss';

interface Props {
  buttonText: string;
  handleClick: () => void;
}

interface ButtonTypes {
  colorProp: string;
  icon: React.ReactNode;
}

const buttonType: { [x: string]: ButtonTypes } = {
  Teach: {
    colorProp: 'grey',
    icon: showRightArrowIcon(),
  },
  Resume: {
    colorProp: 'Resume',
    icon: showRightArrowWhiteIcon(),
  },
  Unarchive: {
    colorProp: 'grey',
    icon: '',
  },
};

const getButton = (textKey: keyof { [x: string]: ButtonTypes }) => {
  return buttonType[textKey];
};

const ClassroomCardButton = ({ buttonText, handleClick }: Props): JSX.Element => {
  let propsToPass: { [x: string]: boolean } | null = {};
  propsToPass[getButton(buttonText).colorProp] = true;
  if (buttonText === 'Resume') propsToPass = null;

  return (
    <div className={styles.classroomCardButton}>
      <Button onClick={handleClick} {...propsToPass}>
        <span className={styles.buttonText}>{buttonText}</span>
        {getButton(buttonText).icon && <span className={styles.icon}>{getButton(buttonText).icon}</span>}
      </Button>
    </div>
  );
};

export default ClassroomCardButton;
